module.exports = __webpack_public_path__ + "07_face.8f482d0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer1/07_face.png
// module id = arIF
// module chunks = 0